import React, { Component } from 'react';
import { connect } from 'react-redux';
import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import Meter from 'grommet/components/Meter';
import Layer from 'grommet/components/Layer';
import App from 'grommet/components/App';
var prg=""
class Progressbar extends Component {
    constructor() {
        super();
        this.state = {
            Text: "",
            progress: 0,
            content2:'Sizing in progress. Please wait while your data is being processed.'
        }
    }

    componentDidMount() {

        let i = 0;
        let interval = 100 / this.props.inputs.length;    
        let progress = interval;
        let timeOut=this.props.TimeInterval/this.props.inputs.length; 
        let tempInput = this.props.inputs;     
        this.setState({ Text: tempInput[i++], progress: progress });         
        prg = setInterval(() => {
            progress += interval;             
            if (i < this.props.inputs.length){
            this.setState({ Text: tempInput[i++], progress: progress });                     
            } 
            else{     
            i++; 
            }     
            if (i === this.props.inputs.length+1) {                           
                this.setState({ content2:'Sizing is completed.  Please wait until system provides sizing data.' });    
                clearInterval(prg)
            }
        }, timeOut);
    }
    render() {

        let layer = ""
        layer = <Layer style={{ zIndex: '500 !important',width:"30%" }}>
            <Box style={{backgroundColor: 'white', width:'100%' }}  pad={{ 'between': 'small' }} size='large'>
            <Box style={{backgroundColor:'#425563',marginBottom:"0px",padding:"10px"}}>
            <Heading tag='h4'   style={{color:'white',marginBottom:'0px'}}>{"Sizer Processing"}</Heading>
            </Box>
              <Box  pad="small"  >  
                <Heading tag='h5' style={{alignSelf:'center',marginBottom:'0px',fontWeight:'400'}}>{"Step : "} {this.state.Text}</Heading>
                <Meter size='large' value={this.state.progress} />                
                 <Heading tag='h4' style={{alignSelf:'center',fontWeight:'400'}}>{this.state.content2}</Heading>                
               </Box> 
            </Box>
        </Layer> 
        return (
            <App centered={false}>
                <Box id="everything" className="everything" >
                    {layer}
                </Box>  
            </App>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        isSizingSolutionPending:state.sessions.isSizingSolutionPending
    }
};
const mapDispatchToProps = (dispatch) => {
  return {
    isSizingSolutionPendingFalse: () => {
      dispatch({type:'ISSIZINGSOLUTION_PENDING',payload:" "});
    },
  }
}
export default connect(mapStateToProps,mapDispatchToProps) (Progressbar);




// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/SizingProgressbar.js